import React, {
  useMemo,
  memo
} from "react";
import {
  StyleSheet
} from "react-native";
import {
  Card
} from "@constants/Themed";
import UsageDistributionPieChart from "@components/Charts/UsageDistributionPieChart";
import {
  getPieChartConfig
} from "@utils/chartTheme";
import {
  themeSelector
} from "@reduxLocal/selectors/themeSelector";
import {
  USAGE_PIE_CHART_COLORS
} from "./config";
interface UsageDistributionPieChartWidgetProps {
  data: {
    companyMembers: number;
    projects: number;
    models: number;
    aiCalls: number;
  };
  isLoading: boolean;
  width: number;
  height: number;
}

const UsageDistributionPieChartWidget: React.FC<
  UsageDistributionPieChartWidgetProps>
  = ({
    data,
    isLoading,
    width,
    height
  }) => {
    const theme = themeSelector();
    const pieChartConfig = useMemo(() => getPieChartConfig("modern", theme), [
      theme,
    ]);

    const usagePieData = useMemo(
      () => [{
        name: "Active Users",
        population: data.companyMembers || 1,
        color: USAGE_PIE_CHART_COLORS.primary,
        legendFontColor: theme ? "#374151" : "#d1d5db",
        legendFontSize: 14,
      }, {
        name: "Projects",
        population: data.projects || 5,
        color: USAGE_PIE_CHART_COLORS.secondary,
        legendFontColor: theme ? "#374151" : "#d1d5db",
        legendFontSize: 14,
      }, {
        name: "Data Models",
        population: data.models || 3,
        color: USAGE_PIE_CHART_COLORS.tertiary,
        legendFontColor: theme ? "#374151" : "#d1d5db",
        legendFontSize: 14,
      }, {
        name: "AI Calls",
        population: data.aiCalls || 25,
        color: USAGE_PIE_CHART_COLORS.quaternary,
        legendFontColor: theme ? "#374151" : "#d1d5db",
        legendFontSize: 14,
      },], [data, theme]
    );

    return (
      <Card style={styles.card}>
        <UsageDistributionPieChart
          data={usagePieData}
          isLoading={isLoading}
          chartConfig={pieChartConfig}
          width={width}
          height={height}
        />
      </Card>
    );
  };

const styles = StyleSheet.create({
  card: {
    width: "100%",
    height: "100%",
    borderRadius: 15,
    overflow: "hidden",
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});

export default memo(UsageDistributionPieChartWidget);
